import { render, staticRenderFns } from "./StatementInvite.vue?vue&type=template&id=22e91a12&"
import script from "./StatementInvite.vue?vue&type=script&lang=js&"
export * from "./StatementInvite.vue?vue&type=script&lang=js&"
import style0 from "./StatementInvite.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports